"use strict";

exports.__esModule = true;
var _resolveDefaultValues = require("./resolve-default-values");
Object.keys(_resolveDefaultValues).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _resolveDefaultValues[key]) return;
  exports[key] = _resolveDefaultValues[key];
});
//# sourceMappingURL=index.js.map